<mat-card-actions style="position: relative; top: -5px; left: 8px; width: 100%; border-bottom-style: inset; border-bottom-color: var(--tdo-blue);" data-cy="config-action-bar-container">
  <ng-container *ngIf="isCustom">
    <ng-content></ng-content>
  </ng-container> 
  <ng-container *ngIf="!isCustom">
    <ng-container *ngIf="showEdit === true">
      <button data-cy="config-action-bar-edit-button" mat-button class="tdo-button tdo-save" (click)="onEdit($event)">Edit</button>
    </ng-container>

    <button data-cy="config-action-bar-new-button" mat-button class="tdo-button tdo-save" *ngIf="!newHidden" [disabled]="newDisabled" (click)="onNew($event)">New <mat-icon iconPositionEnd data-cy="config-action-bar-new-icon">add_circle_outline</mat-icon></button>

    <ng-container *ngIf="showSave === true">
      <button data-cy="config-action-bar-save-button" mat-button class="tdo-button tdo-save" *ngIf="!saveHidden" [disabled]="saveDisabled" (click)="onSave($event)">Save</button>
    </ng-container>

    <ng-container *ngIf="showAdd === true">
      <button data-cy="config-action-bar-add-button" mat-button class="tdo-button tdo-save" (click)="onAdd($event)">Add</button>
    </ng-container>

    <ng-container *ngIf="showCancel === true">
      <button data-cy="config-action-bar-cancel-button" mat-button class="tdo-button tdo-close" (click)="onCancel($event)">Cancel</button>
    </ng-container>

    <ng-container *ngIf="showClear === true">
      <button data-cy="config-action-bar-clear-button" mat-button class="tdo-button tdo-clear" (click)="onClear($event)"> Clear All<mat-icon iconPositionEnd data-cy="config-action-bar-clear-icon">delete</mat-icon></button>
    </ng-container>    
    
  </ng-container>
</mat-card-actions>

